/*
 *  Hopefully a simple set of utilities for
 *  a little bit of extra obfuscation.
 * */

export async function Sha256Hash(pin: string): Promise<string | undefined> {
  if (pin !== "") {
    const bytes: Uint8Array<ArrayBuffer> = new TextEncoder().encode(pin);
    // Crypto.subtle is only available in "secure contexts", so it could
    // fail if someone is running the apps in just HTTP.
    // Maybe need a try ... catch ?
    const hash: ArrayBuffer = await crypto?.subtle?.digest("SHA-256", bytes);
    return Array.from(new Uint8Array(hash), (b) =>
      b.toString(16).padStart(2, "0")
    ).join("");
  }
}
